import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_MODE === 'production') {
  Sentry.init({
    dsn: 'https://983e39059abfd6fd27ce5e515ea9e26c@o4509407100862464.ingest.de.sentry.io/4509407107809360',

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    tracePropagationTargets: [import.meta.env.VITE_API_URL],
  });
}
